(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('CompanySubscriptionStatusViewController', CompanySubscriptionStatusViewController);

    CompanySubscriptionStatusViewController.$inject = ['entity', '$state', '$scope', '$rootScope', '$stateParams', 'CompanySubscriptionStatusCustom', 'SubscriptionPackageCustom', 'CompanyInfoQuery', 'CompanyCustom'];

    function CompanySubscriptionStatusViewController(entity, $state, $scope, $rootScope, $stateParams, CompanySubscriptionStatusCustom, SubscriptionPackageCustom, CompanyInfoQuery, CompanyCustom) {
        var vm = this;
        vm.subscriptionTypeList = [{type: 'BASIC', packages: ''},
            {type: 'ECONOMY', packages: ''},
            {type: 'ENTERPRISE', packages: ''}];
        vm.currentSubscriptionStatus = 'ACTIVE';

        vm.purchase = purchase;
        vm.subscriptionType = null;
        vm.selectSubscriptionType = selectSubscriptionType;
        vm.subscriptionType = 'ECONOMY';
        vm.hasCustomSubscriptionType = false;
        selectSubscriptionType();
        vm.hasSubscription = hasSubscription;

        vm.showSubscriptionType = true;
        CompanySubscriptionStatusCustom.findActiveCompanySubscription().query(function (entity) {
            vm.companySubscriptionStatusList = entity;
        });

        vm.buttonClass = buttonClass;
        vm.packageCardStyle = packageCardStyle;
        vm.borderStyle = borderStyle;
        vm.currentCompany = {};
        vm.currentCompany.activityType = "OTHER";
        findCurrentCompany();


        $scope.$watch('vm.companySubscriptionStatusList', function (entity) {
            if (entity) {
                loadData();
            }


        });

        function loadData() {
            makeSubscriptionPackages();
            checkSubscriptionStatus();
            //if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined &&  vm.companySubscriptionStatusList.length > 0) {
            //    vm.activePackage=vm.companySubscriptionStatusList[0];
            //    if (vm.companySubscriptionStatusList[0].subscriptionPackage != null) {
            //        if (vm.companySubscriptionStatusList[0].subscriptionPackage.subscriptionType != 'FREE') {
            //            vm.subscriptionType = vm.companySubscriptionStatusList[0].subscriptionPackage.subscriptionType;
            //            vm.mode = "purchase";
            //
            //            //selectSubscriptionType();
            //
            //        }
            //    }
            //}
        }

        function purchase() {
            vm.mode = "purchase";
        }

        function selectSubscriptionType() {

            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (result) {
                if (result.subscriptionType != null && result.subscriptionType != '') {
                    vm.subscriptionType = result.subscriptionType;
                    vm.showSubscriptionType = true;
                }

                vm.subscriptionPackages = SubscriptionPackageCustom.getSubscriptionPackageByType(vm.subscriptionType).query();
            })


        }

        function makeSubscriptionPackages() {

            CompanyInfoQuery.getCurrentCompanyInfo().query().$promise.then(function (result) {
                if (result.subscriptionType != null && result.subscriptionType != '') {
                    vm.subscriptionType = result.subscriptionType;
                    vm.showSubscriptionType = false;
                    vm.hasCustomSubscriptionType = false;
                    vm.subscriptionTypeList = [{type: vm.subscriptionType, packages: ''}];
                } else {

                }
                vm.subscriptionTypeList.forEach(function (stype) {
                    stype.packages = SubscriptionPackageCustom.getSubscriptionPackageByType(stype.type).query();
                });
            })


        }

        function checkSubscriptionStatus() {
            if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                vm.activePackage = vm.companySubscriptionStatusList[vm.companySubscriptionStatusList.length - 1];

                vm.currentSubscriptionStatus = 'ACTIVE';
            } else {
                vm.currentSubscriptionStatus = 'EXPIRED';
            }
        }

        function hasSubscription() {

            if (vm.companySubscriptionStatusList != null && vm.companySubscriptionStatusList != undefined && vm.companySubscriptionStatusList.length > 0) {
                if (vm.companySubscriptionStatusList[0].subscriptionPackage != null)
                    return true;
            }
            return false;
        }

        function buttonClass(type) {
            if (type != "BASIC" && type != "ECONOMY" && type != "ENTERPRISE") {
                return "btn-DEFAULT";
            }
            return "btn-" + type;
        }

        function packageCardStyle(type) {
            return "package-card-" + type;
        }

        function borderStyle(type) {
            return "border-" + type;
        }

        function findCurrentCompany() {
            CompanyCustom.getCurrentCompany().query().$promise.then(function (result) {

                vm.currentCompany = result;
            });
        }
    }
})();
